import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

import {
  ALLOWED_CONTEXTS,
  SAV_PLATFORM_CONTEXTS,
  SAV_PLATFORM_ROLES,
} from './Platform/constants'

export default ({ config }) => {
  return [
    // Customer request - Merchant SAV Platform.
    {
      name: ROUTES.SAV_PLATFORM.HOME,
      path: '/bo_merchant/customer-request',
      component: () => {
        const isSSRSwitchedOff = config.KILL_CUSTOMER_REQUESTS_SSR_FOR_SELLER

        return dynamicImport(
          import(
            isSSRSwitchedOff
              ? '@sav-platform/ConnectedSAVPlatformClientOnly'
              : '@sav-platform/ConnectedSAVPlatform'
          ),
        )
      },
      meta: {
        auth: {
          required: true,
          // TODO: Use route names instead
          redirection: ['/bo_merchant/'],
        },
        merchant: {
          required: true,
        },
      },
      props: {
        role: SAV_PLATFORM_ROLES.merchant,
      },
      redirect: {
        name: ROUTES.SAV_PLATFORM.CUSTOMER_REQUESTS.PENDING,
        params: {
          context: SAV_PLATFORM_CONTEXTS.pending,
        },
      },
      children: [
        {
          name: ROUTES.SAV_PLATFORM.INVOICE_REQUESTS,
          path: 'invoice-requests',
          components: {
            rightPanel: () =>
              dynamicImport(
                import('@sav-platform/pages/ConnectedInvoiceRequests.vue'),
              ),
          },
        },
        {
          // TODO Clean context on ASP routes SAX-392
          name: ROUTES.SAV_PLATFORM.CUSTOMER_REQUESTS.PENDING,
          path: ':context(pending)/:customerRequestId([0-9]+)?/:claimId([0-9]+)?',
          meta: {
            scrollToSavedPosition: false,
          },
          components: {
            rightPanel: () =>
              dynamicImport(
                import('@sav-platform/pages/ConnectedCustomerRequests.vue'),
              ),
          },
        },
        {
          name: ROUTES.SAV_PLATFORM.CUSTOMER_REQUESTS.RETURNS,
          path: ':context(returns)/:customerRequestId([0-9]+)?/:claimId([0-9]+)?',
          meta: {
            scrollToSavedPosition: false,
          },
          components: {
            rightPanel: () =>
              dynamicImport(
                import('@sav-platform/pages/ConnectedCustomerRequests.vue'),
              ),
          },
        },
        {
          name: ROUTES.SAV_PLATFORM.CUSTOMER_REQUESTS.CLOSED,
          path: ':context(closed)/:customerRequestId([0-9]+)?/:claimId([0-9]+)?',
          meta: {
            scrollToSavedPosition: false,
          },
          components: {
            rightPanel: () =>
              dynamicImport(
                import('@sav-platform/pages/ConnectedCustomerRequests.vue'),
              ),
          },
        },
        {
          name: ROUTES.SAV_PLATFORM.CUSTOMER_REQUESTS.ALL,
          path: ':context(all)/:customerRequestId([0-9]+)?/:claimId([0-9]+)?',
          meta: {
            scrollToSavedPosition: false,
          },
          components: {
            rightPanel: () =>
              dynamicImport(
                import('@sav-platform/pages/ConnectedCustomerRequests.vue'),
              ),
          },
        },
        {
          name: ROUTES.SAV_PLATFORM.CUSTOMER_REQUESTS.STANDALONE_CONVERSATION,
          path: ':customerRequestId([0-9]+)/:claimId([0-9]+)?',
          meta: {
            scrollToSavedPosition: false,
          },
          components: {
            rightPanel: () =>
              dynamicImport(
                import(
                  '@customer-requests/Platform/pages/seller/StandaloneConversation/StandaloneConversation.vue'
                ),
              ),
          },
        },
        {
          name: ROUTES.SAV_PLATFORM.CUSTOMER_REQUESTS
            .STANDALONE_CONVERSATION_RESOLUTION,
          path: 'resolution/:resolutionId',
          meta: {
            scrollToSavedPosition: false,
          },
          components: {
            rightPanel: () =>
              dynamicImport(
                import(
                  '@customer-requests/Platform/pages/seller/StandaloneConversation/StandaloneConversation.vue'
                ),
              ),
          },
        },
      ],
    },
    // Customer request - Admin SAV Platform.
    {
      name: ROUTES.SAV_PLATFORM_ADMIN.HOME,
      path: '/bo_admin/customer-request',
      component: () => {
        const isSSRSwitchedOff = config.KILL_CUSTOMER_REQUESTS_SSR_FOR_ADMIN

        return dynamicImport(
          import(
            isSSRSwitchedOff
              ? '@sav-platform/ConnectedSAVPlatformClientOnly'
              : '@sav-platform/ConnectedSAVPlatform'
          ),
        )
      },
      meta: {
        auth: {
          required: true,
          // TODO: Use route names instead
          redirection: ['/bo_merchant/'],
        },
        staff: {
          required: true,
        },
      },
      props: {
        role: SAV_PLATFORM_ROLES.admin,
      },
      redirect: {
        name: ROUTES.SAV_PLATFORM_ADMIN.CUSTOMER_REQUESTS,
      },
      children: [
        {
          name: ROUTES.SAV_PLATFORM_ADMIN.RESPONSE_TEMPLATES,
          path: 'response-templates',
          components: {
            rightPanel: () =>
              dynamicImport(import('@sav-templates/ConnectedTemplates')),
          },
        },
        {
          name: ROUTES.SAV_PLATFORM_ADMIN.CUSTOMER_REQUESTS,
          path: `:context(${ALLOWED_CONTEXTS[SAV_PLATFORM_ROLES.admin].join(
            '|',
          )})?/:customerRequestId([0-9]+)?/:claimId([0-9]+)?`,
          meta: {
            scrollToSavedPosition: false,
          },
          components: {
            rightPanel: () =>
              dynamicImport(
                import('@sav-platform/pages/ConnectedCustomerRequests.vue'),
              ),
          },
        },
      ],
    },
    // Customer request - BackCare SAV Platform.
    {
      name: ROUTES.SAV_PLATFORM_BACKCARE.HOME,
      path: '/bo_admin/backcare/customer-request',
      component: () => {
        const isSSRSwitchedOff = config.KILL_CUSTOMER_REQUESTS_SSR_FOR_AGENT

        return dynamicImport(
          import(
            isSSRSwitchedOff
              ? '@sav-platform/ConnectedSAVPlatformClientOnly'
              : '@sav-platform/ConnectedSAVPlatform'
          ),
        )
      },
      meta: {
        auth: {
          required: true,
          // TODO: Use route names instead
          redirection: ['/bo_merchant/'],
        },
        staffOrCareBpo: {
          required: true,
        },
      },
      props: {
        role: SAV_PLATFORM_ROLES.backcare,
      },
      children: [
        {
          name: ROUTES.SAV_PLATFORM_BACKCARE.CUSTOMER_REQUESTS,
          path: `:context(${ALLOWED_CONTEXTS[SAV_PLATFORM_ROLES.backcare].join(
            '|',
          )})?/:customerRequestId([0-9]+)?/:claimId([0-9]+)?`,
          components: {
            rightPanel: () =>
              dynamicImport(
                import('@sav-platform/pages/ConnectedCustomerRequests.vue'),
              ),
          },
        },
      ],
    },
    // Customer request - Static files.
    {
      path: '/seller/certificate-to-transport-investigation',
      name: ROUTES.PDF.CERTIFICATE_TO_TRANSPORT_INVESTIGATION,
      meta: { disableClientSideNavigation: true },
    },
    // Back Office After Sales
    {
      name: ROUTES.SAV_PLATFORM_BACKCARE.AFTER_SALES_CARE_FOLDER_DETAILS,
      path: '/bo_admin/backcare/care-folders/:careFolderId/details',
      meta: {
        auth: {
          required: true,
          // TODO: Use route names instead
          redirection: ['/bo_merchant/'],
        },
        staffOrCareBpo: {
          required: true,
        },
      },
      component: () =>
        dynamicImport(
          import('@sav-platform/pages/agent/OrderDetails/OrderDetails.vue'),
        ),
    },
  ]
}
